var React = require('react');

function LiveTv (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 10L8 13","stroke":"currentColor","key":0}),React.createElement("rect",{"x":"2.5","y":"1.5","width":"11","height":"9","rx":"1.5","stroke":"currentColor","key":1}),React.createElement("line",{"x1":"4","y1":"13.5","x2":"12","y2":"13.5","stroke":"currentColor","key":2}),React.createElement("circle",{"cx":"8","cy":"6","r":"2","fill":"currentColor","key":3})]);
}

LiveTv.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = LiveTv;

LiveTv.default = LiveTv;
